import {
  FolderActions,
  FolderActionTypes,
} from '../actions/folderActions';
import {
  ApiStatus,
  Folder,
} from '../../models';

export const initialFolderState: FolderState = {
  loadingStatus: null,
  creatingStatus: null,
  updatingStatus: null,
  deletingStatus: null,
  folders: null,
}

export interface FolderState {
  loadingStatus: ApiStatus | null;
  creatingStatus: ApiStatus | null,
  updatingStatus: ApiStatus | null;
  deletingStatus: ApiStatus | null;
  folders: Folder[] | null;
}

export default function folderReducer(
  state: FolderState = initialFolderState,
  action: FolderActions,
): FolderState {
  switch (action.type) {
    case FolderActionTypes.LOAD_FOLDERS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADING,
      }
    case FolderActionTypes.LOADING_FOLDERS_FAILED:
      return {
        ...state,
        loadingStatus: ApiStatus.FAILED,
      }
    case FolderActionTypes.LOADED_FOLDERS:
      const newFolders = action.payload.result || [];
      const existingFolderIds = (state.folders || []).map((folder: Folder) => folder.id);

      return {
        ...state,
        loadingStatus: ApiStatus.LOADED,
        folders: [
          ...state.folders || [],
          ...newFolders.filter((folder: Folder) => !existingFolderIds.includes(folder.id)),
        ],
      }
    case FolderActionTypes.UNSET_FOLDERS:
      return {
        ...state,
        folders: null,
        loadingStatus: null,
      }

    case FolderActionTypes.CREATE_FOLDER:
      return {
        ...state,
        creatingStatus: ApiStatus.LOADING,
      }
    case FolderActionTypes.CREATED_FOLDER:
      return handleCreateFolder(state, action);
    case FolderActionTypes.CREATING_FOLDER_FAILED:
      return {
        ...state,
        creatingStatus: ApiStatus.FAILED,
      }

    case FolderActionTypes.UPDATE_FOLDER:
      return {
        ...state,
        updatingStatus: ApiStatus.LOADING,
      }
    case FolderActionTypes.UPDATING_FOLDER_FAILED:
      return {
        ...state,
        updatingStatus: ApiStatus.FAILED,
      }
    case FolderActionTypes.UPDATED_FOLDER:
      return handleUpdateFolder(state, action);

    case FolderActionTypes.DELETE_FOLDER:
      return {
        ...state,
        deletingStatus: ApiStatus.LOADING,
      }
    case FolderActionTypes.DELETING_FOLDER_FAILED:
      return {
        ...state,
        deletingStatus: ApiStatus.FAILED,
      }
    case FolderActionTypes.DELETED_FOLDER:
      return handleDeleteFolder(state, action);
    default:
      return state;
  }
}

// Functions

function handleCreateFolder(
  state: FolderState,
  action: any
): FolderState {
  const folders = state.folders || [];

  return {
    ...state,
    folders: [
      action.payload,
      ...folders,
    ],
    creatingStatus: ApiStatus.LOADED,
  }
}

function handleUpdateFolder(state: FolderState, action: any): FolderState {
  return {
    ...state,
    updatingStatus: ApiStatus.LOADED,
    folders: state.folders?.map(folder => {
      if (folder.uid === action.payload.uid) {
        return action.payload;
      }
      return folder;
    }) || null,
  }
}

function handleDeleteFolder(state: FolderState, action: any): FolderState {
  const folder = state.folders?.find((folder: Folder) => folder.uid === action.payload);
  let newFolders = state.folders?.filter(folder => folder.uid !== action.payload) || [];

  if (folder) {
    /*
     * Update deleted folder children `parent_id` with deleted folder's parent_id;
     */
    newFolders = newFolders.map((f: Folder) => {
      if (f.parent_id === folder.id) {
        return {
          ...f,
          parent_id: folder.parent_id,
        }
      }

      return f;
    });
  }

  return {
    ...state,
    folders: newFolders,
    deletingStatus: ApiStatus.LOADED,
  }
}
